import { useState } from "react";
import { useCollection } from "@/hooks/useCollection";
import { PageHeader } from "@/components/crm/common";
import { ProjectSelect } from "@/components/crm/ProjectSelect";
import { PocPanel } from "@/components/crm/PocPanel";

export default function ProjectPoc() {
  const { items: projects, update } = useCollection("projects");
  const { items: team } = useCollection("team");
  const [pid, setPid] = useState(new URLSearchParams(window.location.search).get("project") || "");
  const p = projects.find((x) => x.id === pid);
  return (
    <>
      <PageHeader num="17" title="Project POC & Team" subtitle="Six dedicated responsibility assignments per project. Contacts come from the Team Hub directory.">
        <ProjectSelect projects={projects} value={pid} onChange={setPid} />
      </PageHeader>
      {p && <PocPanel project={p} team={team} update={update} />}
    </>
  );
}
